import httpClient from '../utils/httpClient';
import { logoutApi } from "../api/authApi";

export const logoutUser = async (navigate, showToast) => {
    try {
        let apiLogoutSuccess = true;
        try {
            const response = await logoutApi();
            apiLogoutSuccess = response?.Message?.[0]?.ReturnCode === "1";

            if (!apiLogoutSuccess && showToast) {
                showToast({
                    title: "Logout failed",
                    message:
                        response?.Message?.[0]?.ReturnMessageDesc ||
                        "Server logout failed. Logging out locally.",
                    type: "warn",
                });
            }
        } catch (err) {
            apiLogoutSuccess = false;
        }
        const rememberedUser = localStorage.getItem("rememberedUser");
        const rememberedPassword = localStorage.getItem("rememberedPassword");
        localStorage.clear();
        sessionStorage.clear();

        if (rememberedUser) {
            localStorage.setItem("rememberedUser", rememberedUser);
        }
        if (rememberedPassword) {
            localStorage.setItem("rememberedPassword", rememberedPassword);
        }

        sessionStorage.clear();
        navigate("/login", { replace: true });

    } catch (error) {
        console.error("Logout failed:", error);
    }
};

export const UserLogout = async () => {
    const response = await httpClient.post('/User/logout');
    return response.data;
};
